import { call, put, takeLeading } from 'redux-saga/effects';
import { trialApi } from '../api/trial-api';
import {
  fetchTrialDaysRequest,
  fetchTrialDaysSuccess,
  fetchTrialDaysFailure,
} from './trial-slice';

// Saga para obtener días de prueba restantes
function* fetchTrialDaysSaga(): Generator<any, void, any> {
  try {
    const response: any = yield call(trialApi.getTrialDaysRemaining);
    yield put(fetchTrialDaysSuccess(response));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'Error al obtener los días de prueba restantes';
    yield put(fetchTrialDaysFailure(errorMessage));
  }
}

// Watcher saga
// GH#1875 — takeLeading (no takeLatest): en la carga, el Sidebar (montado dos veces:
// móvil + escritorio) y el TrialExpiredBanner disparan fetchTrialDaysRequest casi a la
// vez → 3 llamadas a /subscriptions/trial-days. takeLatest cancelaba las previas PERO
// la request ya salía al cable. takeLeading atiende la primera e IGNORA las que llegan
// mientras está en vuelo: 3 → 1. Un fetch posterior (refresh) sí vuelve a pedir.
export function* trialSaga(): Generator<any, void, any> {
  yield takeLeading(fetchTrialDaysRequest.type, fetchTrialDaysSaga);
}



